"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfiguracaoIntervalos = void 0;
var bson_1 = require("bson");
var ConfiguracaoIntervalos = /** @class */ (function () {
    function ConfiguracaoIntervalos(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.intervaloGeral, intervaloGeral = _c === void 0 ? 100 : _c, _d = _a.filtros, filtros = _d === void 0 ? [] : _d;
        this._id = _id;
        this.intervaloGeral = intervaloGeral;
        this.filtros = filtros;
    }
    return ConfiguracaoIntervalos;
}());
exports.ConfiguracaoIntervalos = ConfiguracaoIntervalos;
//# sourceMappingURL=ConfiguracaoIntervalos.js.map